import { render, staticRenderFns } from "./CashNotAccount.vue?vue&type=template&id=0b1f16de&scoped=true&"
import script from "./CashNotAccount.vue?vue&type=script&lang=js&"
export * from "./CashNotAccount.vue?vue&type=script&lang=js&"
import style0 from "./CashNotAccount.vue?vue&type=style&index=0&id=0b1f16de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f16de",
  null
  
)

export default component.exports